/**
 * Periodic pseudo-noise, period 800 m along z so the world loops seamlessly (GDD §3.3; concept L28–L40).
 */
import { PERIOD } from '../core/math.ts';

export const ZK = (Math.PI * 2) / PERIOD;

export function pn(x: number, z: number): number {
  return (
    0.5 * Math.sin(x * 0.031 + z * ZK * 7 + 1.3) +
    0.35 * Math.sin(x * 0.067 - z * ZK * 13 + 0.2) * Math.cos(x * 0.021 + z * ZK * 5) +
    0.22 * Math.sin(x * 0.13 + z * ZK * 29 + 2.1) +
    0.12 * Math.sin(x * 0.27 - z * ZK * 53 + 0.7) +
    0.07 * Math.sin(x * 0.53 + z * ZK * 101 + 4.1)
  );
}

export function pd(x: number, z: number): number {
  return (
    0.5 * Math.sin(x * 0.9 + z * ZK * 157 + 0.3) * Math.sin(x * 0.43 - z * ZK * 211) +
    0.3 * Math.sin(x * 1.7 - z * ZK * 331 + 1.9) +
    0.2 * Math.sin(x * 2.9 + z * ZK * 467 + 0.8)
  );
}
